<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{ 'Seleccionar colaboradores'}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="personaevaluar != '' ">
                                <inputCustom [titulo]="'Persona a Evaluar'" [(ngModel)]="personaevaluar" [verError]="false" [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="departamento != '' ">
                                <inputCustom [titulo]="'Departamento'" [(ngModel)]="departamento" [verError]="false" [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="puesto != '' ">
                                <inputCustom [titulo]="'Puesto'" [(ngModel)]="puesto" [verError]="false" [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="nivel != '' ">
                                <inputCustom [titulo]="'Nivel'" [(ngModel)]="nivel" [verError]="false" [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="grado != '' ">
                                <inputCustom [titulo]="'Grado'" [(ngModel)]="grado" [verError]="false" [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="grupo != '' ">
                                <inputCustom [titulo]="'Grupo'" [(ngModel)]="grupo" [verError]="false" [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="fechaaplicacion != '' ">
                                <inputCustom [titulo]="'Fecha de aplicacion'" [(ngModel)]="fechaaplicacion" [verError]="false" [disabled]="true"></inputCustom>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'N° nómina'" [(ngModel)]="entidad.nomina" [verError]="false"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'Nombre'" [(ngModel)]="entidad.nombre" [verError]="false"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'Ap. paterno'" [(ngModel)]="entidad.apellidopaterno" [verError]="false"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'Ap. materno'" [(ngModel)]="entidad.apellidomaterno" [verError]="false"></inputCustom>
                            </div>
                        </div>

                        <!-- Botones de filtrado -->
                        <div class="row">
                            <div class="col-12">
                                <div class="panelBotonesFiltro">
                                    <button class="boton botonSM filledBlanco" (click)="LimpiarFiltros()">
                                        {{'Limpiar' | translate}}
                                    </button>

                                    <div class="divisorH16"></div>

                                    <button class="boton botonSM filled" (click)="Buscar()">
                                        {{'Consultar' | translate}}
                                    </button>
                                </div>

                            </div>
                        </div>

                        <div class="divisorgris"></div>
                        <div class="divisor16"></div>

                        <!-- datos -->
                        <dx-data-grid
                        #grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="dataTable"
                            [showColumnHeaders]="true"
                            >

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>

                            <dxo-selection *ngIf="seleccionMultiple"
                            [selectAllMode]="'allPages'"
                            [showCheckBoxesMode]="'always'"
                            mode="multiple"
                          ></dxo-selection>
                          <dxo-selection *ngIf="!seleccionMultiple"
                            [selectAllMode]="'allPages'"
                            [showCheckBoxesMode]="'always'"
                            mode="single"
                          ></dxo-selection>

                            <dxi-column
                                dataField="nomina"
                                caption="N° de nómina">
                            </dxi-column>
                            <dxi-column
                                dataField="nombre"
                                caption="Nombre">
                            </dxi-column>
                            <dxi-column
                                dataField="apellidopaterno"
                                caption="Ap. paterno">
                            </dxi-column>
                            <dxi-column
                                dataField="apellidomaterno"
                                caption="Ap. materno">
                            </dxi-column>
                            <dxi-column
                            dataField="departamento"
                            caption="Departamento">
                            </dxi-column>
                            <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                            </dxi-column>
                            <dxi-column 
                            dataField="nivel"
                            caption="Nivel">
                            </dxi-column>
                            <dxi-column *ngIf="vermateria"
                            dataField="materia"
                            caption="Materia">
                            </dxi-column>

                        </dx-data-grid>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            Cancelar
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            Seleccionar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
